import { createSelector } from '@reduxjs/toolkit';

import type { CoreRootState } from '../../CoreStore';
import type { VideoConfig } from '../../slices/config/types';

export const hasVideoLocation = createSelector(
  [
    ({ config }: CoreRootState): VideoConfig | null | undefined => config.videoConfig,
    ({ videoSlice }: CoreRootState): string | null => videoSlice.hlsLocation,
    ({ videoSlice }: CoreRootState): string | null => videoSlice.videoLocation,
  ],
  (videoConfig, customVideoLocation, customHlsLocation): boolean => {
    /**
     * nullish check is important here.
     * Since MTB will set and use empty string values for videoLocation and hlsLocation from videoSlice
     */
    const videoLocation = customVideoLocation ?? videoConfig?.videoLocation;
    const hlsLocation = customHlsLocation ?? videoConfig?.hlsLocation;
    return Boolean(videoLocation || hlsLocation);
  }
);
